import React from 'react';
import { Panel, Button } from 'react-bootstrap';
import PagedEntitiesList from '../../common/components/PagedEntitiesList';
import ListActions from '../../common/components/ListActions';
import ui from '../../common/services/ui';
import { FormControl } from 'react-bootstrap';
import { actions } from './modes/common';
import TermsDropdownList from '../terms/DropdownList';

const selectedTerm = (selectedCenterTerms, centerId) => {
	if (!selectedCenterTerms || !selectedCenterTerms[centerId]) {
		return;
	}

	return selectedCenterTerms[centerId].termId;
};

const renderSelectTerm = (selectedTerms, centerId, onSelectTerm, t) => {
	const termId = selectedTerm(selectedTerms, centerId);
	const onChange = (newTermId) => onSelectTerm(centerId, newTermId);
	return (
		<TermsDropdownList value={termId} onChange={onChange} emptyLabel={t('WeeklyProgram_ChooseTerm')} centerId={centerId} />
	);
};

const renderActions = (centerId, termId, t, history, onShowNotification, enableSingleProgram) => {
	return (
		<div>
			{actions(enableSingleProgram).map((action) => renderAction(centerId, termId, action, t, history, onShowNotification))}
		</div>
	);
};

const renderAction = (centerId, termId, action, t, history, onShowNotification) => {
	const path = buildPath(centerId, termId, action);
	const handleNavigation = () => history.push(path);
	return (
		<p key={action.type}>
			<Button bsStyle='link' onClick={() => handleActionClick(termId, action.type, handleNavigation, onShowNotification)}>
				<strong className={action.classes}>{t(action.resourceText)}</strong>
			</Button>
		</p>
	);
};

const buildPath = (centerId, termId, action) => {
	let path;
	if (action.type === 'copy') {
		path = `/weeklyProgram/action?type=${action.type}&centerId=${centerId}`;
	} else {
		path = `/weeklyProgram/action?type=${action.type}&centerId=${centerId}&termId=${termId}`;
	}
	return path;
};

const handleActionClick = (termId, type, onNavigate, onShowNotification) => {
	const hasSelectedTerm = termId && termId !== -1;
	if (type !== 'copy' && !hasSelectedTerm) {
		if (onShowNotification) {
			onShowNotification('WeeklyProgram_SelectTerm');
		}
		return;
	}
	onNavigate();
};

// `rest` deliberately still contains t/onSelectTerm/onShowNotification/enableSingleProgram:
// they are read here *and* forwarded to PagedEntitiesList below. This used to be written as
// `{ isReadonly, selectedTerms, history, ...rest, t, ... }`, which Babel 6 accepted but is
// invalid — a rest element must come last. Destructuring from `rest` keeps the original
// behaviour; moving `...rest` to the end would have dropped those four props.
const List = ({ isReadonly, selectedTerms, history, ...rest }) => {
	const { t, onSelectTerm, onShowNotification, enableSingleProgram } = rest;
	const columns = [
		{
			header: t('WeeklyProgram_Center'),
			accessor: 'name',
			sortable: true
		},
		{
			header: t('WeeklyProgram_Term'),
			accessor: 'id',
			cellClassName: 'weekly-program-term-cell',
			cell: (centerId) => renderSelectTerm(selectedTerms, centerId, onSelectTerm, t)
		},
		{
			header: t('Common_Actions'),
			accessor: 'id',
			cell: (centerId, row) => {
				const termId = selectedTerm(selectedTerms, centerId);
				return renderActions(centerId, termId, t, history, onShowNotification, enableSingleProgram);
			}
		}
	];

	return (
		<Panel>
			{/*
				This opens a view for entering a new center, however entering a new center requires a franchisor and
				a territory. The view for entering a new center currently does not have inputs for franchisee and territory.
				For this reason it is unusable, when rendered from here.
				<ListActions isReadonly={isReadonly} newItemPath='/weeklyProgram/new?prev=/weeklyProgram' />
			*/}
			<Panel.Body>
				<PagedEntitiesList columns={columns} {...rest} />
			</Panel.Body>
		</Panel>
	);
};

export default List;